import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 424 424",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h424v424H0z" }),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M234.031 334.624 350.196 218.46c4.687-4.686 4.687-12.284 0-16.97l-68.408-68.408c-4.686-4.686-12.284-4.686-16.97 0L148.653 249.246l-33.782-33.782L253.556 76.78c9.763-9.763 25.592-9.763 35.355 0l117.675 117.675c9.764 9.763 9.764 25.593 0 35.356L267.901 368.495z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#04a9f5",
				d: "M275.523 174.93 159.358 291.095c-4.687 4.686-12.284 4.686-16.97 0l-68.409-68.408c-4.686-4.686-4.686-12.284 0-16.97L190.145 89.55l-33.782-33.78L17.678 194.454c-9.763 9.763-9.763 25.593 0 35.356l117.675 117.675c9.763 9.763 25.592 9.763 35.355 0L309.393 208.8z"
			})
		]
	})
});
export default SvgLogoIap;
